/**
 * Alcance de escritura de las asignaciones de packs/membresías (US-2.4, TG-53).
 *
 * El contrato declara las escrituras (`POST /packs`, `PUT/DELETE /membership`,
 * `DELETE /packs/{id}` y la subida de comprobantes) **solo para `SUPER_ADMIN`**. El
 * resto de roles con lectura (`SOPORTE_N3`, `MARKETING`, `ALIADO_ADMIN`) ve la
 * sección en modo consulta. La UI refleja la matriz para no ofrecer botones que
 * terminarían en un `403`.
 */
import type { AdminRole } from '@goelectric/shared-types';

/** Roles que pueden asignar/cancelar packs y membresías y subir comprobantes. */
export const ASSIGNMENT_WRITE_ROLES: readonly AdminRole[] = ['SUPER_ADMIN'];

/** `true` si el rol puede ejecutar acciones de escritura sobre asignaciones. */
export function canWriteAssignments(role: AdminRole | undefined): boolean {
  return role !== undefined && ASSIGNMENT_WRITE_ROLES.includes(role);
}
